
import React, { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { TextInput, Button,Breadcrumb, Slot,Search, Icon, Dropdown,Link, Notification, Sidepanel, TextArea, DataTable } from "pepsico-ds";
import { useForm, Controller } from "react-hook-form";
import "./svc_account.css";
import axios from "axios";
import { useLoading } from "../../loader";
import forge from "node-forge";
import { toast,ToastContainer  } from 'react-toastify';
import PamNoDataApproval from "../../common/pam_no_data_approval";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const publicKey = `-----BEGIN RSA PUBLIC KEY-----
    MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAsoZnlKyNcmMo3zrdx3KGc+/+fk1Jn7zYVyENg8hf6+SQ+p03Mzx8+hO6QUWgkJtlQfWBabZWMolGcpr37QTs4LJc6IEdvy24b8SjWM8AXj6II+SRpOR1m7W9I0eD16+6/nLWBpB5FAxCjrODC//BZVvGStXnTfQZc+/E2EamK21DneFkJaC9FlTwoNSy+LM5bjf6Q2YjWuX06uePzaAOLnycyhA8fHMoHwBQLdzfpKwRKMOr3VnDilem9RH9zGi44rg8y2g2TY1WzvsStmDM8NduV5aOnwzFMo+BTugfLhdP4ZmYR/BX5WLfPmxkAEI5fVNONBCuzoJsyX424wMLlwIDAQAB
    -----END RSA PUBLIC KEY-----`;
export const encrypt = (plainText, key) => {
  const publicKey = forge.pki.publicKeyFromPem(key);
  return forge.util.encode64(
    publicKey.encrypt(plainText, "RSA-OAEP", {
      md: forge.md.md5.create(),
      mgf1: {
        md: forge.md.sha1.create(),
      },
    })
  );
};

export const encryptAES = async (msg) => {
  const key = crypto.getRandomValues(new Uint8Array(16)); // 128-bit key
  const iv = crypto.getRandomValues(new Uint8Array(12)); // 96-bit IV (recommended for AES-GCM)

  const cryptoKey = await crypto.subtle.importKey(
    "raw",
    key,
    { name: "AES-GCM" },
    true,
    ["encrypt"]
  );

  const encodedMsg = new TextEncoder().encode(msg);

  const encrypted = await crypto.subtle.encrypt(
    { name: "AES-GCM", iv },
    cryptoKey,
    encodedMsg
  );

  return {
    key: btoa(String.fromCharCode(...key)), // Convert to Base64 for storage
    iv: btoa(String.fromCharCode(...iv)),
    encrypted: btoa(String.fromCharCode(...new Uint8Array(encrypted))),
  };
};

const SvcAccountRequestApproval = () => {
  const { t } = useTranslation();
  const { REACT_APP_API_ENDPOINT } = process.env;
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [showCreateNewSafe,setShowCreateNewSafe] = useState(false);
  const [accountNames,setAccountNames] = useState([]);
  const [userSvcData,setUserSvcData] = useState('');
  const [domains,setDomains] = useState([]);
  const [address,setAddress] = useState([]);
  const [platforms,setPlatforms] = useState([]);
  const [type,setType] = useState([]);
  const [userDn,setUserDn] = useState([]);
  const { showLoader, hideLoader } = useLoading();
  const[userDnRequired,setUserDnRequired] = useState(false);
  const[showSidePanel,setShowSidePanel] = useState(false);
  const[showChangeOwnerSidePanel,setShowChangeOwnerSidePanel] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const[selectedAccount,setSelectedAccount] = useState('')
  const [users,setUsers] = useState([])
  const [applications,setApplications] = useState([]);
  const[safeMembers,setSafeMembers] = useState([]);
  const selectedGPID = useRef('')
  const [selectedUser,setSelectedUser] = useState('')
  const [selectedGpid,setSelectedGpid] = useState('')
  const [selectedApp,setSelectedApp] = useState('')
  const [gpid,setGpid] = useState('')
  const [appName,setAppName] = useState('')
  const [safeName,setSafeName] = useState([])
  const [newSafeValue,setNewSafeValue]= useState('');
  const [appSearchText,setAppSearchText] = useState('')
  const [prefixValue, setPrefixValue] = useState("AP_");
  const [columns, setColumns] = useState(
    [
      { columnKey: "gpid", header: "GPID", showColumnVisibility: true,size:300 },
      { columnKey: "svcAccountName", header: "Account Name", showColumnVisibility: true,size:400 },
      { columnKey: "accountType", header: "Account Type",size:400},
      { columnKey: "domain", header: "Domain",size:400 },
      { columnKey: "address", header: "Address",size:400},
      { columnKey: "", header: "Action",size:400,  cellData: (ctx) => {
      return <>
        <Button
          className=""
          size="medium"
          style={{height:'auto',fontWeight:"bold",textAlign:"left"}}
          text="Onboard into myPAM"
          variant="tertiary"
          onClick={(e)=>{
            clickdRow(e, ctx.row.original,false)
          }}
          // onChange={(e) => onRowSelectionChange(e, ctx.row.original)}
        />
        
          </> 
          }
      },
      { columnKey: "", header: "Change",size:400,  cellData: (ctx) => {
          return <>
          
            <Button
              className=""
              size="medium"
              style={{height:'auto'}}
              text="Change Account Owner"
              variant="primary"
              onClick={(e)=>{
                clickdRow(e, ctx.row.original,true)
              }}
              // onChange={(e) => onRowSelectionChange(e, ctx.row.original)}
            />
            </> 
              }
      }]
  );
  
    const [query, setQuery] = React.useState('');

    const debouncedSearch = useDebouncedCallback((q) => {
      // Enforce min 3 chars before hitting API
      if (q.trim().length >= 3) {
        searchApplications(q);
      } else {
        setApplications([]);
      }
    }, 2000);

    const [queryGPID, setQueryGPID] = React.useState('');
    const debouncedSearchGPID = useDebouncedCallback((q) => {
      // Enforce min 3 chars before hitting API
      if (q.trim().length >= 3) {
        gpidSerach(q);
      } else {
        setUsers([]);
      }
    }, 2000);

  // const onRowSelectionChange = (e, user) => {
  //   e.stopPropagation();
  //   setSelectedRow(user);
  //   // selectedGPID.current = user.uid;
  // };
  const normalizeSel = (val) => (Array.isArray(val) ? val[0] ?? null : val ?? null);
  const PREFIX = "AP_";

  const handleChange = (e) => {
    let v = e.target.value;

    if (!v.startsWith(PREFIX)) {
    v = PREFIX + v.replace(PREFIX, "");
  }

    setPrefixValue(v);
  };

const clickdRow = (e,row,changeOwner)=>{
  console.log('111111111111',e);
  setSelectedAccount(row);
  setOtherValues(row,changeOwner);
  
}

const updateAppSearchText = (val) => {
  setAppSearchText(val);
};

const [toasts, setToasts] = useState([]);
  const showToast = (index, message, type) => {
    setToasts([
      {
        id: `toast-${index}`,
        duration: 10000,
        text: message,
        type: type,
        position: "bottom-right",
      },
    ]);
  };

  const removeToast = (id) => {
    setToasts((prevToasts) => prevToasts.filter((toast) => toast.id !== id));
  };

  const gpidSerach =(val) =>{
    console.log('2222222222222',val);
    if (val.length < 3){
      return
    }
    showLoader();
    axios.post(REACT_APP_API_ENDPOINT + "user/searchuser", {
      'gpid' : val
      }).then((response)=>{
        console.log('hello');
        hideLoader();
          
        const mapped = Object.values(response?.data?.userData).map(item => ({
          id: item.uid,
          label: `${item.uid} - ${item.sn}  ${item.givenName}`
        }));

        setUsers(mapped);
        hideLoader();
      }).catch((error)=>{
          hideLoader();
          toast.error(error?.message)
          console.log('error', error);
    })
    }
  useEffect(()=>{
    setColumns([
        { columnKey: "createdAt", header: "Date Requested", showColumnVisibility: true,size:300 },
        { columnKey: "gpid", header: "GPID", showColumnVisibility: true,size:300 },
        { columnKey: "svcAccountName", header: "Account Name", showColumnVisibility: true,size:300 },
        { columnKey: "accountType", header: "Account Type",size:300},
        { columnKey: "domain", header: "Domain",size:300 },
        { columnKey: "address", header: "Address",size:300},
        { columnKey: "", header: "Action",size:300,  cellData: (ctx) => {
        return <>
          <Button
            className=""
            size="small"
            style={{height:'auto',fontWeight:"bold",textAlign:"left"}}
            text={"Approve"}
            variant="tertiary"
            onClick={(e)=>{
              clickdRow(e, ctx.row.original,false)
            }}
            disabled={!!ctx.row.original?.hasPendingRequest}
            // onChange={(e) => onRowSelectionChange(e, ctx.row.original)}
          />
          </> 
          }
          }
          ])
  },[selectedRow]);
  const [safes,setSafes]= useState([]);
  const [environments,SetEnvironments] =useState([
    {
      id:'PR',displayText:'PR'
    },
    {
      id:'DV',displayText:'DV'
    },
    {
      id:'IT',displayText:'IT'
    },
    {
      id:'QA',displayText:'QA'
    },
    {
      id:'PP',displayText:'PP'
    }
  ])
  const {
    control,
    register,
    handleSubmit,
    setValue,
    reset,
    formState: { isValid, isSubmitting, errors },
    watch,
  } = useForm({
    defaultValues:{
      mode: 'onChange',
      reValidateMode: 'onChange',
      safeName: null,
      fullAppName:null,
      existingPassword: '',
      existingRetypePassword: '',
      appName:'',
      environment:'',
      teamname:''

    }
  });

  // const appName = watch("appName");
  const environment = watch("environment");
  const teamname = watch("teamname");

  const existingPassword = watch('existingPassword');
  const existingRetypePassword = watch('existingRetypePassword');
  const getUserSvcDetails = () => {
    showLoader();
    axios
      .get(REACT_APP_API_ENDPOINT + "pam/pendingApprovals", {
      })
      // .then(response => response.json())
      .then((response) => {
        console.log('99999999999',response);
        
        if(response?.data?.status == "Failed"){
          toast.error(response?.data?.errorMessage);
          hideLoader();
        }
        else{
          // toast.success("SVC account data fetched successfully.");
          let usersvcdata = response?.data;
          let res = usersvcdata;
          console.log('1212121212',res);
          
          setUserSvcData(usersvcdata.approvals);
          // const svcNames = res?.svcAccounts.map((acc, i) => ({
          //   id: acc.name || `unnamed_${i}`,       // fallback if name missing
          //   displayText: acc.name + '-' +acc.type || `Unnamed #${i}`
          //   }));
          //   setAccountNames(svcNames);
          hideLoader();
        } 
        
      })
      .catch((error) => {
        hideLoader();
        console.error("Error fetching data:", error);
        return '';
      });
  };
  useEffect(() => {
    getUserSvcDetails();
  }, []);
  
  const setOtherValues = (opt) => {
    setShowSidePanel(true) ;
    console.log("setOtherValues opt:", opt);
    const svcSafes = opt?.safeDetails?.map((acc,i)=>({
      id: acc,       // fallback if name missing
      displayText: acc || `Unnamed #${i}`
    }));
    setSafes([{ id: "create_new", displayText: "Create new" },...svcSafes]);
    let sel;
    if(opt){
      sel = opt;
      // let accType = sel.displayText.split('-');
      if(sel.accountType == 'AD'){
        setUserDnRequired(false);
      }
      else{
        setUserDnRequired(true);
      }
    }
    else{
      setDomains([]);
      setAddress([]);
      setPlatforms([]);
      setType([]);
      setUserDn('');
      setValue("domain", [], { shouldValidate: true, shouldDirty: true });
      setValue("type", [], { shouldValidate: true, shouldDirty: true });
      setValue("address", [], { shouldValidate: true, shouldDirty: true });
      setValue("platform", [], { shouldValidate: true, shouldDirty: true });
      setValue("userDn", '',{ shouldValidate: true, shouldDirty: true })
      return;
    }

    // if (!sel) return;

    const accounts = opt ?? [];
    // if (!Array.isArray(accounts) || accounts.length === 0) return;
    console.log('2222222222222',accounts);
    
    // const accIndex = accounts.findIndex((a) => a?.name === sel.id);
    // console.log('33333333333333333333',accIndex);
    
    if (!accounts) {
      console.warn(`No account found for name "${sel.id}"`);
      // Clear dependent values if no match
      setDomains([]);
      setAddress([]);
      setPlatforms([]);
      setType([]);
      setUserDn('');
      setValue("domain", [], { shouldValidate: true, shouldDirty: true });
      setValue("type", [], { shouldValidate: true, shouldDirty: true });
      setValue("address", [], { shouldValidate: true, shouldDirty: true });
      setValue("platform", [], { shouldValidate: true, shouldDirty: true });
      setValue("userDn", { shouldValidate: true, shouldDirty: true })
      return;
    }
   
    const acc = accounts;
    const typeTxt = acc.accountType
    const accountOpt ={
      id: acc.svcAccountName,
      displayText: acc.svcAccountName,
    };
    const accountType ={
      id: acc.accountType,
      displayText: acc.accountType,
    };
    const domainOpt = {
      id: acc.domain,
      displayText: acc.domain,
    };
    const addressOpt = {
      id: acc.address,
      displayText: acc.address,
    };
    const platformOpt = {
      id: acc.platform,
      displayText: acc.platform,
    };
    const applicationOpt = {
      id: acc.applicationName,
      displayText: acc.applicationName,
    };
    let safeOpt;
    if(acc.isNewSafe){
      safeOpt = {
        id:"create_new",
        displayText:"create_new"
      }
    }
    else{
      safeOpt = {
        id: acc.safeName,
        displayText: acc.safeName,
      };  
    }

    // Update option lists shown by the Domain/Address/Platform dropdowns
    setAccountNames([accountOpt])
    setDomains([domainOpt]);
    setAddress([addressOpt]);
    setPlatforms([platformOpt]);
    setType([accountType])
    setAppName(applicationOpt)
    setSafeName([safeOpt])
    if(acc?.safeMembers?.length > 0){
      setSafeMembers(acc.safeMembers)
    } else {
      setSafeMembers([])
    }

    // Programmatically set the selected values in the form (RHF)
    setValue("accountName", [accountOpt]);
    setValue("domain", [domainOpt]);
    setValue("type", [accountType]);
    setValue("address", [addressOpt]);
    setValue("platform", [platformOpt]);
    setValue("fullAppName",applicationOpt);
    setValue("safeName",[safeOpt])
    if(acc.isNewSafe){
      setShowCreateNewSafe(true);
      setNewSafeValue(acc.safeName);
      setValue("newSafe",acc.safeName)
    }
    
    // Optionally set userDn if provided
    if (acc.userdn) {
      setUserDn('');
      console.log('4444444444444444',acc.userdn);
      setUserDn(acc.userdn)
      setValue("userDn", [acc.userdn]);
    }
    
  };
 
  // normalize to string id for payload
  const toId = (v) => {
    if (v == null) return "";
    if (typeof v === "string") return v;
    return v.id ?? "";
  };

  const onSubmit = (values) => {
    console.log('44444444444444444',values);
    let encryptedPwd = encrypt(values.existingPassword, publicKey);
    let isNewSafe = values?.safeName[0].id === 'create_new'? true : false;
    console.log('121313131313',selectedAccount);
	
    const payload = {
      requestNumber: selectedAccount.requestNumber,
      action: "APPROVE",
      svcAccountName: values?.accountName[0]?.id,
      applicationName:values?.fullAppName[0]?.id,
      accountType: values?.type[0]?.id,
      domain: values?.domain[0]?.id,
      address: values?.address[0].id,
      userdn: values?.userDn ? values?.userDn[0] : '',
      platform: values?.platform[0].id,
      isNewSafe:isNewSafe,
      overrideSafeName: isNewSafe ? values.newSafe : values?.safeName[0].id,
      overrideSafeMembers: safeMembers,
      // secret: encryptedPwd,
    };

    console.log("Submitting:", payload);
    
    showLoader();
    axios
      .post(REACT_APP_API_ENDPOINT + "/pam/approveAccountRequest", 
        payload
      )
      // .then(response => response.json())
      .then((data) => {
        let approveResponse = data?.data;
        if(approveResponse?.status != 'FAILED'){
          toast.success("Account Onboarded to myPAM Successfully!");
          getUserSvcDetails();
          reset();
          hideLoader();
          setShowSidePanel(false);
        }
        else{
          approveResponse?.message ? toast.error(approveResponse?.message): toast.error(approveResponse?.errorMessage);
          
          getUserSvcDetails();
          hideLoader();
          reset();
          setShowSidePanel(false);
        }
      })
      .catch((error) => {
        toast.error(error?.message)
        hideLoader();
        console.error("Error fetching data:", error);
        return '';
      });
  };

  const onSubmitChangeOwner = (values)=>{
      console.log('1111111111',values);
    
      const payload = {
        svcAccountName: values?.accountName[0]?.id,
        accountType: values?.type[0]?.id,
        domain: values?.domain[0]?.id,
        address: values?.address[0]?.id,
        userdn: values?.userDn,
        platform: values?.platform[0]?.id,
        ownergpid: values?.ownerGpid.id,
      };
      console.log("Submitting:", payload);
      
      showLoader();
      axios
        .post(REACT_APP_API_ENDPOINT + "/pam/submitAccount", 
          payload
        )
        // .then(response => response.json())
        .then((data) => {
          let usersvcdata = data?.data;
          if(userSvcData?.status == 'Sucess'){
            toast.success("Request Submitted Successfully!");
            getUserSvcDetails();
            reset();
            hideLoader();
            setShowSidePanel(false);
          }
          else{
            toast.error(usersvcdata?.errorMessage);
            getUserSvcDetails();
            hideLoader();
            reset();
            setShowSidePanel(false);
          }
        })
        .catch((error) => {
          toast.error(error?.message)
          hideLoader();
          console.error("Error fetching data:", error);
          return '';
        });
  }

  const onClickSelect = () => {
    let statePayload = {};
    console.log('111111111111',selectedRow);
    
    if (selectedRow) {
      
      setShowSidePanel(true);
    }
  }
  const clearUsers =()=>{
    setUsers([]);
    setQueryGPID(null);
  }
  const onClickCancel = () => {
      // navigate('/myidmPortal')
  }

  // const searchApplications = (text) =>{
  //   showLoader();
  //   axios.post(REACT_APP_API_ENDPOINT + "pam/getApplicationList", {
  //   'appFilter' : text
  //   }).then((response)=>{
  //     console.log('22222222222222',response);
  //     const mapped = Object.values(response?.data?.appList).map(item => ({
  //       id: item,
  //       label: item
  //     }));
  //     setApplications(mapped);
  //     hideLoader();
  //   }).catch((error)=>{
  //       hideLoader();
  //       console.log('error', error);
  // })
  // }

  
const searchApplications = async (text: string) => {
  if (!text || text.trim().length < 3) {
    // Optional: guard min length here too
    setApplications([]);
    return;
  }
  try {
    showLoader();
    const response = await axios.post(
      `${REACT_APP_API_ENDPOINT}pam/getApplicationList`,
      { appFilter: text }
    );
    const list = response?.data?.appList ?? {};
    const mapped = Object.values(list).map((item: string) => ({
      id: item,
      label: item,
    }));
    setApplications(mapped);
  } catch (error) {
    toast.error(error.message)
    console.log('error', error);
  } finally {
    hideLoader();
  }
};


  function useDebouncedCallback(callback, delay = 1000) {
    const timerRef = React.useRef();

    const debounced = React.useCallback((...args) => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
      timerRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    }, [callback, delay]);

    // Cleanup to avoid calling setState after unmount
    React.useEffect(() => {
      return () => {
        if (timerRef.current) {
          clearTimeout(timerRef.current);
        }
      };
    }, []);

    return debounced;
  }
  
  const addToSafeMembers = (val) => { 
    if (!val || !val.id) return;

    setSafeMembers(prev =>
      prev.some(item => item.id === val.id)
        ? prev
        : [...prev, val]
    );
  };

  const removeFromSafeMembers =(gpidToRemove) =>{
    setSafeMembers(prev => prev.filter(item => item?.id !== gpidToRemove));
  }

  const makeSetSelectedValue = (onChange) => (opt) => {
    console.log('2222222222222',opt);
    setShowCreateNewSafe(false);
    if(opt && opt[0]?.id=='create_new'){
      setShowCreateNewSafe(true);
    }
  };

  return (
    <div>
    <Breadcrumb
        homeIcon={{
          icon: "home",
          onClick:()=>{
            navigate("/home")
          }
        }}
        breadcrumbs={[
          {
            label: "Home",
          },
          {
            label: <div onClick={()=>{
              navigate("/pam-svc-account-approval")
            }}>myPAM Service Account Onboarding Request Approval</div>
          },
        ]}
        className="ml-3"
        onClick={function Xs() {}}
        useAnchor
        style={{ marginBottom: "1rem !important" }}
      />
      <div
        className={isMobile ? "row" : "container"}
        style={{
          background: "none",
          boxShadow: "none",
          justifyContent: isMobile ? "center" : "",
        }}
      >
        {userSvcData && userSvcData?.length > 0 &&
        <div className="mt-2"
          style={{
            flexDirection: isMobile ? "column" : "row",
            gap: isMobile ? "0px" : "15px",
            flexWrap: "wrap",
            flex: 1,
          }}
        >
          <div className={`${isMobile ? 'pl-4 pr-4 ml-4 mr-4' : 'd-flex mb-0'}  align-items-center`} style={{justifyContent:'space-between'}}>
            <h4 className={`${isMobile ? 'mb-1' : 'mbn'}`}>{"myPAM Service Account Approval"}</h4>
            <div className="hello">
            
            </div>
        </div>
          {/* Left Section */}
          <div
            className="card card-layout reg-card mb-3 mb-md-0"
            style={{
              flex: isMobile ? "unset" : "0 0 calc(66.666% - 7.5px)",
              width: isMobile ? "100%" : "auto",
            }}
          >
            <div className="card-content align-items-center">
              {/* <h4 className="mbn">{"myPAM Service Account Approval"}</h4> */}
                <div className="request-new-access-for-others-main-content h-100 m-0" style={{width:'100% !important'}}>
                  <div className="search-result"></div>
                   <DataTable
                      className="datatable"
                      columns={columns}
                      enableSorting={true}
                      data={userSvcData}
                      pageIndex={0}
                      pageSize={10}
                      // searchPlaceholder={t("RequestGPIDForNonEmployee.search_placeholder")}
                      selection="single"
                      tableHeader="Data table header"
                      size="large"
                      showTableHeader ={true}
                      showTitle={true}
                      showSearchOption={false}
                      showColumnFilters={false}
                      showDescription={false}
                      tableDescription=""
                      showPagination={true}
                  /> 
                
              </div>
            </div>
          </div>
        </div>
        }
        {!userSvcData || userSvcData.length === 0 && 
          <PamNoDataApproval />
        }
      </div>
      {/* <div>
        <p className="mr-3 mb-1 mt-0" style={{textAlign:'right'}}>Any questions, please reach out to DL - myPAMEngineering@pepsico.com</p>
      </div> */}
    <div>
  <Sidepanel
    className=""
    linkProps={{
      iconLeading: '',
      iconTrailing: 'arrow_forward',
      label: 'Link',
      onClick: function ERe(){},
      size: 'medium'
    }}
    onCloseSidePanel={(event)=>{console.log('1212121212',event);
      if(event.type == 'mousedown' || event.type == "mouseup"){
        event.preventDefault();
        return;
      };setShowSidePanel(false);setShowCreateNewSafe(false);reset();}}
    primaryButtonProps={{
      onClick: function ERe(){},
      size: 'medium',
      text: 'Submit',
      variant: 'primary'
    }}
    showSidePanel={showSidePanel}
    secondaryButtonProps={{
      onClick: function ERe(){},
      size: 'medium',
      text: 'Cancel',
      variant: 'secondary'
    }}
    showFooter = {false}
    showLink ={false}
    showSecondaryButton
    showTertiaryButton ={false}
    style={{}}
    closeOnOutsideClick={false}
    tertiaryButtonProps={{
      onClick: function ERe(){},
      size: 'medium',
      text: 'Button',
      variant: 'tertiary'
    }}
    title={"Account Name : " + accountNames[0]?.displayText + "[" + domains[0]?.displayText + "]"}
    type="vertical"
    verticalSidepanelHeight="40% !important"
  >
    <form
      className="form-size pro-form pb-3"
      onSubmit={handleSubmit(onSubmit,(errs) => {
          console.warn('Submit blocked by validation:', errs);
        })}
    >
      <div className="form-grid"> 
        {/* User DN */}
        {/* {userDnRequired && 
        <div className="form-field">
          <TextArea
            label={t("User DN")}
            placeholder={t("User DN")}
            showCharacterCount
            showToolbar={false}
            showLabelIcon={false}
            required={userDnRequired}
            {...register("userDn", {
              required: t("User DN is required"),
              minLength: { value: 3, message: t("User DN is too short") },
            })}
            aria-invalid={!!errors.userDn}
            helperText={errors.userDn?.message ?? ""}
            className=""
            style={{ width: "100%" }}
            value ={userDn}
          />
        </div>
        } */}

        {/* Safe Name */}
        <div className="form-field">
        <Controller
          name="safeName"
          control={control}
          
          rules={{
            required: t('Safe Name is required'),
            minLength: {
              value: 8,
              message: t('Enter 8 digits')
            }
          }}
          render={({ field, fieldState }) => (
            <Dropdown
              childList={safes}
              label={t('Safe Name')}
              selection="single"
              isClearable
              isRequired
              menuPosition="bottom-right"
              showLabelIcon
              size="medium"
              selectedValue={field.value}

              // If your Dropdown exposes setSelectedValue, bridge it to RHF:
              setSelectedValue={(val) => {
                field.onChange(val);     
                // makeSetSelectedValue(sel); 
                setShowCreateNewSafe(Boolean(val && val[0].id === 'create_new'));
              }}

              // Nice-to-have wiring if supported by your component:
              onBlur={field.onBlur}
              inputRef={field.ref}

              // Show validation message from RHF:
              helperText={fieldState.error?.message ?? ''}
              isInvalid={!!fieldState.error}
            />
          )}
        />
        </div>
        
        {showCreateNewSafe && (
          <>
            {/* New Safe (conditional) */}
            <div className="form-field">
            <Controller
            name="newSafe"
            control={control}
            rules={{
              required: t('New Safe name is required'),
              maxLength: {
                value: 28,
                message: "Maximum 28 characters allowed"
              }
            }}
            render={({ field, fieldState }) => (
              <TextInput
                type="text"
                className="input-margin-top-bottom-0"
                
                // required={true}
                value ={field.value ?? ""}
                onChange={(e) => field.onChange(e.target.value.toUpperCase())}
                // readOnly={true}
                maxLength={19}
                label={t("New Safe")}
                required={true}
                onPaste={(e) => e.preventDefault()}
                // error={!!fieldState.error}
                helperText={fieldState.error?.message ?? ""}
                style={{ width: "100%" }}
              />
            )}
            />
            </div>

            {/* <div className="form-field">
            <Controller
              name="environment"
              control={control}
              defaultValue=""
              rules={{
                required: t('Environment is required'),
              }}
              render={({ field, fieldState }) => (
                <Dropdown
                  childList={environments}
                  label={t('Environment')}
                  selection="single"
                  isClearable
                  isRequired
                  menuPosition="bottom-right"
                  showLabelIcon
                  size="medium"
                  selectedValue={field.value}

                  // If your Dropdown exposes setSelectedValue, bridge it to RHF:
                  setSelectedValue={(val) => {
                    field.onChange(val);
                  }}

                  // Nice-to-have wiring if supported by your component:
                  onBlur={field.onBlur}
                  inputRef={field.ref}

                  // Show validation message from RHF:
                  helperText={fieldState.error?.message ?? ''}
                  isInvalid={!!fieldState.error}
                />
              )}
            />
            </div> */}

            {/* <div className="form-field">
            <Controller
            name="teamname"
            control={control}
            render={({ field, fieldState }) => (
              <TextInput
                type="text"
                className="input-margin-top-bottom-0"
                // required={true}
                // value ={prefixValue}
                // readOnly={true}
                label={t("Team Name")}
                onChange={(e) => field.onChange(e.target?.value ?? e)}
                // required={true}
                placeholder="Enter Abbreviation of team name"
                onPaste={(e) => e.preventDefault()}
                helperText={fieldState.error?.message ?? ""}
                style={{ width: "100%" }}
              />
            )}
            />
            </div> */}

            {/* <div className="form-field">
              
            <Controller
              name="appName"
              control={control}
              rules={{
              required: t("App name is required"),
              }}
              render={({ field,fieldState }) => (
              <TextInput
                type="text"
                className="input-margin-top-bottom-0"
                onChange={(e) => field.onChange(e.target?.value ?? e)}
                required={true}
                label={t("Short Name of the application")}
                // value ={prefixValue}
                // onChange={handleChange}
                // prefix="ap-pr-"
                // aria-invalid={!!errors.appName}
                helperText={fieldState.error?.message ?? ""}
                style={{ width: "100%" }}
              />
            )}
              />
            </div> */}
          </>
        )}
        {/* <div>
          <label className="safe-name">Safe Members</label>
        </div>
        <div style={{display:'flex',alignItems:'center',gap:'5px'}}>
        <Search
          isAutoComplete
          isClearable
          onClear={()=>clearUsers()}
          onSelectOption={(val) =>{
            gpidSerach(val)
            setSelectedUser(val);
          }}
          onSearch={(event) => gpidSerach(event)}
          onUpdate={(text)=>{
            setQueryGPID(text);
            debouncedSearchGPID(text);
            }}
          placeholderText="Search a GPID to add members to safe"
          size="medium"
          style={{width:'95%'}}
          autoComplete="off"
          suggestions={users}
        />
        <Icon
          alt="alt value"
          className="$color-icon-default"
          icon="add_box"
          size="medium"
          onClick={()=>addToSafeMembers(selectedUser)}
          style={{width:'5%'}}
        />
        </div> */}
        {safeMembers.length > 0 && <div>
        <label className="safe-name">Safe Members</label>
        <div className="accountsAlign">
          {safeMembers?.map((acc, index) => (
            <span key={acc} className="endPointInfo mr-1">{acc}{" "} 
            {/* <Icon
            alt="alt value"
            className="$color-icon-default"
            icon="close"
            size="small"
            onClick={()=>removeFromSafeMembers(acc?.id)}
            style={{color:'white'}}
          /> */}
          {" "}</span>
          ))}
        </div>
        </div> 
        }
        
        <div className="form-field">
        <label className="safe-name">Application</label>
          <Controller          
            name="fullAppName"
            control={control}
            defaultValue={null}
            rules={{
              // required: t("Application name is required"),
              // validate: (v) => {
              //   const sel = normalizeSel(v);
              //   return sel ? true : t("Please select an application from the list");
              // },
            }}
            render={({ field, fieldState }) => (
              <>
              <Search
                isAutoComplete
                isClearable={false}
                // required
                isDisabled={true}
                isRequired
                value={appName.id}
                // onClear={() => {
                //   setSelectedApp(null);
                //   field.onChange(null);
                // }}
                // onSelectOption={(val) => {
                //   const sel = Array.isArray(val) ? val[0] : val;
                //   setSelectedApp(sel);
                //   field.onChange(sel);
                // }}
                // onSearch={(val) => searchApplications(val)}
                // onUpdate={(text) => {
                //   setQuery(text);
                //   debouncedSearch(text); //debounce
                // }}
                placeholderText="Search for an application"
                size="medium"
                autoComplete="off"
                // suggestions={applications}
                selectedValue={field.value}
                errorText={fieldState.error?.message}
              />
              {fieldState?.error && <div className="feedback $font-xsmall-regular info dropdown-hint $spacing-mt03 medium"><Icon
                alt="alt value"
                className="icon $color-icon small material-icons-outlined"
                icon="info"
                size="small"
                style={{}}
              />{fieldState?.error?.message}</div>
            }
              </>
            )}
          />
        </div>
      </div>

      {/* Actions */}
      <div className="form-actions">
        <div></div>
        <div>
          <Button
            variant="primary" 
            type="submit"
            size="medium"
            disabled={!isValid || isSubmitting}
            >
            {t("Approve")}
          </Button>
          {/* 
          <Button
            type="button"
            size="medium"
            className="secondary-button"
            onClick={() => reset()}
            disabled={!isDirty || isSubmitting}
          >
            {t("Reset")}
          </Button> 
          */}
          
        </div>
        
      </div>
      
    </form>
  </Sidepanel>

</div>
      <ToastContainer
        position="bottom-center"
        data={toasts}
        removeToast={removeToast}
      />
  </div>
  );
};

export default SvcAccountRequestApproval;
